// extracted by mini-css-extract-plugin
export var aircallIframe = "_fi-3";
export var fabContainer = "_fi-5";
export var fabRinging = "_fi-6";
export var loadingOverlay = "_fi-4";
export var pulse = "_fi-7";
export var widgetContent = "_fi-2";
export var widgetPanel = "_fi-0";
export var widgetPanelExpanded = "_fi-1";